// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OZQC","col":"styles_col__2Om_q"};